/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment.development';
import { Observable, switchMap, tap } from 'rxjs';
import { LoginResponse } from '../models/login-response';
import { UserInfo } from '../../../features/users/models/user-info';
import { Router } from '@angular/router';
import { AuthenticationResult } from '@azure/msal-browser';
import { MsalService } from '@azure/msal-angular';
// import { SocialAuthService, SocialUser } from '@abacritt/angularx-social-login';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private baseUrl = environment.backURL;
  constructor(
    private readonly http: HttpClient,
    private readonly msalService: MsalService,
    // private readonly socialAuthService: SocialAuthService,
    private readonly router: Router,
  ) {
    this.msalService.instance.initialize().then(() => {
      console.log('MSAL initialized');
    });
  }

  login(username: string, password: string): Observable<LoginResponse> {
    const url = `${this.baseUrl}/login`;
    const body = { username, password };
    return this.http.post<LoginResponse>(url, body);
  }

  loginAAD(): Observable<any> {
    return this.msalService
      .loginPopup({ scopes: [], prompt: 'select_account' })
      .pipe(
        tap((result: AuthenticationResult) => {
          this.msalService.instance.setActiveAccount(result.account);
        }),
        switchMap((result: AuthenticationResult) =>
          this.checkUserInBackend(result),
        ),
      );
  }

  // TODO: Implementar Google SSO en futuro
  // loginGoogle(user: SocialUser): Observable<any> {
  //   const url = `${this.baseUrl}/google/check`;
  //   const body = {
  //     idToken: user.idToken,
  //     username: user.email,
  //     validationType: 'v2',
  //   };
  //   return this.http.post(url, body);
  // }

  saveSession(response: LoginResponse): Observable<UserInfo> {
    localStorage.setItem('token', response.token);
    localStorage.setItem('refresh_token', response.refresh_token);
    return this.getLoggedUserInfo().pipe(
      tap((userInfo) => {
        localStorage.setItem('email', userInfo.email);
        localStorage.setItem('role', userInfo.role);
      }),
    );
  }

  refreshToken(): Observable<LoginResponse> {
    const url = `${this.baseUrl}/token/refresh`;
    const refreshToken = this.getRefreshToken();
    const body = { refresh_token: refreshToken };
    return this.http.post<LoginResponse>(url, body);
  }

  getToken(): string {
    return localStorage.getItem('token') || '';
  }

  getRefreshToken(): string {
    return localStorage.getItem('refresh_token') || '';
  }

  async logout(): Promise<void> {
    try {
      if (this.hasAzureSession()) {
        await this.logoutAzureSession();
      }
      // TODO: Manejar logout de Google cuando esté implementado
      // else {
      //   await this.logoutSocialSession();
      // }
    } catch (error) {
      console.error('Logout failed', error);
    } finally {
      this.clearClientSession();
      await this.router.navigate(['/login']);
    }
  }

  private checkUserInBackend(result: AuthenticationResult): Observable<any> {
    const url = `${this.baseUrl}/azure/check`;
    const body = {
      idToken: result.idToken ?? '',
      username: result.account.username ?? '',
    };
    return this.http.post(url, body);
  }

  private getLoggedUserInfo(): Observable<UserInfo> {
    const url = `${this.baseUrl}/users/info`;
    return this.http.get<UserInfo>(url);
  }

  private hasAzureSession(): boolean {
    console.log('Checking for Azure AD session ');
    return this.msalService.instance.getAllAccounts().length > 0;
  }

  private async logoutAzureSession(): Promise<void> {
    console.log('Logging out from Azure AD session');
    await this.msalService.instance.clearCache();
  }

  // TODO: Implementar logout de Google cuando esté habilitado
  // private async logoutSocialSession(): Promise<void> {
  //   try {
  //     await this.socialAuthService.signOut();
  //   } catch (error) {
  //     if (
  //       error !== 'Not logged in' &&
  //       error !==
  //         'Login providers not ready yet. Are there errors on your console?'
  //     ) {
  //       throw error;
  //     }
  //   }
  // }

  private clearClientSession(): void {
    this.msalService.instance.setActiveAccount(null);
    localStorage.clear();
    sessionStorage.clear();
  }
}

